import { matchPath } from 'react-router-dom';

/**
 * Path patterns that mirror the routes registered in `src/main.tsx`.
 *
 * Used by the `<Sso>` page to validate a `redirect_to` target: anything that
 * does not match one of these patterns falls back to `/`. Keep this list in
 * sync when routes change — an out-of-sync entry only causes a graceful
 * fallback to `/` (it never breaks navigation).
 */
export const KNOWN_ROUTE_PATTERNS = [
  '/',
  '/projects',
  '/library',
  '/community-library',
  '/clips',
  '/plans',
  '/plans/:planId',
  '/tutorials',
  '/courses/:slug',
  '/courses/:slug/:moduleOrder',
  '/api-keys',
  '/api-requests',
  '/api-documentation',
  '/api-getting-started',
  '/api-reference',
  '/api-playground',
  '/templates',
  '/template-new',
  '/templates/:id',
  '/brand-kits',
  '/brand-kits-new',
  '/brand-kits/:id',
  '/branding',
  '/historic',
  '/project/:projectId/clips',
  '/project/:projectId/edit',
  '/library/:id/edit',
  '/library/:libraryId/clips',
  '/library/:libraryId/debug',
  '/clips/:id/edit',
  '/invitation/:token',
  '/link/:code',
  '/invoice',
  '/challenge/:id',
  '/campaigns/:id',
  '/earn',
  '/earn/wallet',
  '/rankings',
  '/ranks',
  '/login',
  '/login/microsoft',
  '/login/microsoft/callback',
  '/login/google/callback',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/sso',
  '/cupom/:code',
  '/app-handoff',
  '/share',
  '/font-preview',
  '/terms',
  '/privacy',
  '/terms-and-privacy',
  '/plans-list',
  '/purchase-complete',
  '/admin/resultados',
  '/admin/users',
  '/admin/users/:id',
  '/admin/projects',
  '/admin/clips',
  '/admin/downloads',
  '/admin/coupons',
  '/admin/email-flows',
  '/admin/email-flows/new',
  '/admin/email-flows/:id',
  '/admin/payouts',
  '/admin/contatos',
  '/admin/challenges',
  '/admin/challenges/:challengeId/participants',
  '/admin/challenges/:challengeId/clips',
  '/admin/challenges/:challengeId/participants/:participantId/audit',
  '/admin/challenges/:challengeId/rankings',
  '/admin/library',
  '/admin/brand-kit-new',
  '/admin/campaigns',
  '/admin/channels',
  '/admin/campaigns/new',
  '/admin/campaigns/:id',
  '/admin/campaigns/:id/submissions',
  '/admin/campaigns/:id/participants',
  '/campaign-audit',
  '/campaign-audit/:id',
  '/campaign-audit/:id/participants',
] as const;

/**
 * Returns true if `pathname` matches one of the app's known route patterns
 * (param segments like `/clips/:id/edit` are matched correctly).
 */
export const isKnownRoute = (pathname: string): boolean =>
  KNOWN_ROUTE_PATTERNS.some((pattern) => matchPath(pattern, pathname) != null);
